// Shared semantic tokens for the application shell and public marketing pages.
export const workspaceColors = {
  canvas: '#F8FAFA', surface: '#FFFFFF', hover: '#F1F5F9',
  primary: '#0F766E', primaryHover: '#115E59', selected: '#E7F4F2',
  ink: '#0F172A', secondary: '#475569', muted: '#64748B', disabled: '#94A3B8',
  border: '#DFE9E7', info: '#004EAA', infoBg: '#EFF6FF',
  violet: '#7C3AED', violetBg: '#F5F3FF', rose: '#BE185D', roseBg: '#FDF2F8', success: '#15803D', successBg: '#F0FDF4',
  warning: '#B45309', warningBg: '#FFFBEB', error: '#DC2626', errorBg: '#FEF2F2',
};
export const workspaceVariables = Object.fromEntries(
  Object.entries(workspaceColors).map(([name, value]) => [`--workspace-${name}`, value]),
);
const fieldFocusTokens = { activeShadow: 'none', errorActiveShadow: 'none', warningActiveShadow: 'none' };

export const workspaceTheme = {
  components: {
    Input: fieldFocusTokens,
    InputNumber: fieldFocusTokens,
    DatePicker: fieldFocusTokens,
    Select: { controlOutlineWidth: 0 },
  },
  token: {
    colorPrimary: workspaceColors.primary, colorInfo: workspaceColors.info,
    colorPrimaryHover: workspaceColors.primaryHover, colorPrimaryBg: workspaceColors.selected,
    colorLink: workspaceColors.primary, colorSuccess: workspaceColors.success,
    colorWarning: workspaceColors.warning, colorError: workspaceColors.error,
    colorText: workspaceColors.ink, colorTextSecondary: workspaceColors.secondary,
    colorTextPlaceholder: workspaceColors.muted, colorBorder: workspaceColors.border,
    colorBorderSecondary: workspaceColors.border, colorBgContainer: workspaceColors.surface,
    colorBgLayout: workspaceColors.canvas, controlHeight: 42, borderRadius: 10,
    colorInfoBg: workspaceColors.infoBg, colorSuccessBg: workspaceColors.successBg,
    colorWarningBg: workspaceColors.warningBg, colorErrorBg: workspaceColors.errorBg,
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
};
